import { AccountStatus, LLMChoices, Metric } from "@/types";

export enum Agent {
  user = "user",
  assistant = "assistant",
}

export interface MessageFeedback {
  liked: boolean | null;
  description: string;
}

export interface ChatData {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  extra?: {
    section_ids: string[];
    metric_ids: string[];
    response_quality: LLMChoices;
  };
}

export type Files = {
  id: string;
  file_name: string;
  public_url: string;
};

export interface MessageCreative {
  id: string;
  name: string;
  type: "image" | "video";
  thumbnail_url: string;
  media_url: string;
}

export interface MessageType {
  response: string;
  reasoning?: string;
  answer?: string;
  agent: (typeof Agent)[keyof typeof Agent];
  created_at: string;
  chat_conversation_id?: string | null;
  time_taken: number | null;
  feedback?: MessageFeedback | null;
  data_filters?: DataFilters;
  data_point_id?: string;
  annotations?: Record<string, string>[];
  attachments?: Files[];
  creatives?: MessageCreative[];
  report?: {
    id: string;
    title: string;
  };
  sections?: {
    id: string;
    title: string;
  }[];
  chat_id?: string;
  user_chat_conversation_id?: string | null;
  status?: "loading" | "in_progress" | "completed" | "error";
  icon?: string | null;
  text?: string;
  type?: "reasoning" | "answer";
  done?: boolean;
  explanation?: string;
  assistant_chat_conversation_id?: string | null;
  metrics?: {
    id: string;
    label: string;
  }[];
}

export interface DataFilters {
  metric: {
    metrics: Metric[];
    order_by: {
      metric_name: string;
      order_type: string;
    };
  };
  asset: {
    date_ranges: {
      start_date: string;
      end_date: string;
    }[];
    assets: {
      campaign_ids_required: string[];
      adset_ids_required: string[];
      ad_ids_required: string[];
      is_account_level: boolean;
    };
  };
  section_ids: string[];
  reasonings: string[];
}

export interface ChatSource {
  id?: string;
  title?: string;
  icon?: React.ReactNode;
  sectionIds: string[];
  metricIds?: string[];
}

export interface InsightAccount {
  default?: boolean;
  id: string;
  name: string;
  platform?: "GOOGLE" | "FACEBOOK" | "TIKTOK" | "LINKEDIN";
  status?: (typeof AccountStatus)[keyof typeof AccountStatus];
  platform_creation_time_stamp?: string;
}

export interface ChatHistory {
  chat_conversation_id: string;
  response: string;
  time_taken: number;
  agent: Agent;
  feedback: null;
  created_at: string;
  data_filters: {
    report?: {
      id: string;
      title: string;
    };
    sections?: {
      id: string;
      title: string;
    }[];
    metrics?: {
      id: string;
      label: string;
    }[];
    creatives?: MessageCreative[];
    reasonings?: string[];
    explanation?: string | null;
    overview_ids?: string[];
    structure_ids?: string[];
  } | null;
  data_point_id: string | null;
  annotations: Record<string, string>[] | null;
  attachments: Files[];
}
